var React = require('react');

function ShowPassword (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 3L14.65 4.54C13.39 3.21 11.23 2 8 2C4.77 2 2.61 3.21 1.35 4.54L0 3C1.44 1.27 4.72 0 8 0C11.28 0 14.56 1.27 16 3ZM10 5C10 6.1 9.1 7 8 7C6.9 7 6 6.1 6 5V4C5.25 4.18 4.5 4.61 4 5.02C4.01 7.22 5.8 9 8 9C10.2 9 11.99 7.21 12 5.02C11.5 4.62 10.76 4.18 10 4V5Z","fill":"#231F20"}));
}

ShowPassword.defaultProps = {"width":"16","height":"9","viewBox":"0 0 16 9","fill":"none"};

module.exports = ShowPassword;

ShowPassword.default = ShowPassword;
